module.exports = __webpack_public_path__ + "9f6909c54eb1b105b03f907c9db83249.png";